module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.transactions.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.emptyTransactionsMessage) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.transactions.length > 0) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Transaction date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Last update date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.actionName))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.transactions), function(transaction) {
    return _c('tr', {
      key: transaction.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.transactionId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(transaction.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(transaction.amount)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(transaction.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(transaction.status == 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("cancelled")]) : _vm._e(), _vm._v(" "), (transaction.status == 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("failed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(transaction.id)
        }
      }
    }, [_vm._v("\n              View details\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.handleArchiveUnarchiveTransaction(transaction)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.actionName) + "\n            ")])])])
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23d6c09b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FailedTransactionTabView.vue
// module id = 2119
// module chunks = 1